import { Box } from "@chakra-ui/layout";
import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import PageHeader from "components/Page/PageHeader";
import useFiltroCobranca from "./hooks/useFiltroCobrança";
import ListingPageHeaderBar from "ui/components/Page/ListingPageHeaderBar";
import ListagemCobrancas from "./components/ListagemCobrancas/index";
import { useState } from "react";
import ModalFiltrosCobranca from "./components/ModalFiltrosCobranca/index";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function DashboardPage() {
  const { tenant } = useCurrentTenant();
  const [modalFiltroOpen, setModalFiltroOpen] = useState(false);
  const { filtro, onChangeFiltro, onResetFiltro } = useFiltroCobranca();

  useBreadcrumb([
    { name: "Financeiro" },
    { name: "Receita" },
    { name: "Cobranças" },
  ]);

  const numeroFiltroSelecionados =
    (filtro.contasBancariasIds?.length ? 1 : 0) +
    (filtro.pessoasIds?.length ? 1 : 0) +
    (filtro.tipoContatoAcordo ? 1 : 0) +
    (filtro.unidadesIds ? 1 : 0);

  return (
    <>
      <Container>
        <PageHeader title="Cobranças" mb="24px" />
        <Box mb={6}>
          <ListingPageHeaderBar
            valueSearch={filtro.search || ""}
            onSearch={(v) => {
              onChangeFiltro({ search: v });
            }}
            showOrderByButton
            badge
            badgeValue={numeroFiltroSelecionados}
            visibleFiltro
            onFiltro={() => setModalFiltroOpen(true)}
            // children={
            //   <TagStatusFiltroCobranca
            //     tipoContatoAcordo={filtro.tipoContatoAcordo}
            //     onSelectAcordadoPor={(tipoContatoAcordo) =>
            //       onChangeFiltro({ tipoContatoAcordo })
            //     }
            //   />
            // } TODO -> Retornar isso quando tiver correto
            orderByOptions={[
              {
                value: "totalDividas",
                label: "Quantidade de dividas",
              },
            ]}
            orderBy={filtro.orderBy}
            onOrderByChange={(orderBy) => {
              onChangeFiltro({
                orderBy,
              });
            }}
            orderDirection={filtro.orderDirection}
            onOrderDirectionChange={(orderDirection) => {
              onChangeFiltro({
                orderDirection,
              });
            }}
          />
        </Box>

        <ListagemCobrancas filtroCobranca={filtro} />
      </Container>

      <ModalFiltrosCobranca
        tenantId={tenant.id}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        onReset={onResetFiltro}
        open={modalFiltroOpen}
        onClose={() => setModalFiltroOpen(false)}
      />
    </>
  );
}

export default DashboardPage;
